// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"3438812d","483":"43792c4e","787":"b79c3401","845":"d4e9bcb4"}[chunkId] + ".chunk.js";
};